export default __webpack_public_path__ + "static/media/logo-white.573e7f9b.svg";